module.exports = __webpack_public_path__ + "img/qrcode.4a49a9f7.jpg";